module.exports = __webpack_public_path__ + "img/goDown.b9a98909.png";